import NavigationBar from "../components/navigationBar";
import PageNotFound404 from "../components/pageNotFound404";
import FooterView from "../components/footerView";


export default function PageNotFound() {

    return (
        <div>

            <NavigationBar />
            <PageNotFound404 />
            <FooterView />
        </div>
    )
}